export default "__VITE_ASSET__L9ntv$t2__"